// extracted by mini-css-extract-plugin
export default {"faqpage":"FAQPage_faqpage__L3nGY"};